import React, { useEffect } from 'react';
// import { Route, Switch, useLocation } from 'react-router-dom';
// import { animated, useTransition } from 'react-spring';
import Home from 'components/Home/Home';
import electronUtils from 'utils/electronUtils';
import useStore from 'state/state';
// import NotFound from 'components/NotFound/NotFound';
import styles from './app.module.scss';

const App = () => {
  const setIsOffline = useStore((state) => state.setIsOffline);

  useEffect(() => {
    if (electronUtils.isElectron()) {
      setIsOffline(true);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <Home />
    </div>
  );
};
export default App;
